import { render, staticRenderFns } from "./live-away.vue?vue&type=template&id=a27c1bd6&scoped=true&"
import script from "./live-away.vue?vue&type=script&lang=js&"
export * from "./live-away.vue?vue&type=script&lang=js&"
import style0 from "./live-away.vue?vue&type=style&index=0&id=a27c1bd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27c1bd6",
  null
  
)

export default component.exports